import React, { useState } from "react";
import "./solutions.scss";
import Zoom from "react-reveal/Zoom";
import Flip from "react-reveal/Flip";
import Flash from "react-reveal/Flash";
import { MathComponent } from "mathjax-react";
import MathJax from "react-mathjax";
import { CopyBlock, dracula } from "react-code-blocks";
import { problem_3a, problem_3b, TopBar } from "../../snippets";

const Two = (props) => {
  const [language, changeLanguage] = useState("JavaScript");
  const [language_b, changeLanguage_b] = useState("JavaScript");
  const [languageDemo, changeDemo] = useState(problem_3a["JavaScript"]);
  const [languageDemo_b, changeDemo_b] = useState(problem_3b["JavaScript"]);
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const [process, setProcess] = useState(false);
  const [maxNum, setMaxNum] = useState(600851475143);
  const [scaleProcess, setScaleProcess] = useState(false);
  const [maxNumScale, setMaxNumScale] = useState(600851475143);

  //problem implementation logic
  const runProcess = (n) => {
    let prime = 2;
    while (n >= prime) {
      if (n % prime === 0) {
        n = n / prime;
      } else {
        prime++;
      }
    }
    return prime;
  };

  const shoot = () => {
    setProcess(true);
  };

  const runProcessScale = (n) => {
    var a = Date.now();
    const endPoint = parseInt(Math.sqrt(n));
    let largest = n,
      i = 1;
    while (i <= endPoint) {
      if (n % i === 0 && isPrime(i)) {
        n = n / i;
        largest = i;
      }
      i++;
    }
    if (n > 1 && isPrime(n)) {
      return n;
    }
    console.log(Date.now() - a);
    return largest;
  };

  //check if factor is a prime
  function isPrime(factor) {
    const endPoint = parseInt(Math.sqrt(factor));
    let i = 2;
    while (i <= endPoint) {
      if (factor % i === 0) {
        return false;
      }
      i++;
    }
    return true;
  }

  const shootScale = () => {
    setScaleProcess(true);
  };

  return (
    <div>
      <p>
        Prime factor is a factor that is also a prime number. It is divisible by
        1 and itself only. The prime factorization formula of any number is
        given as:
        <MathComponent tex={String.raw`N = X^a × Y^b × Z^c`} />
        where, <br />
        <blockquote>
          N = Any number X, Y, and Z = Prime factors of number N <br />
          a, b, and c = exponents of prime factors X, Y, and Z respectively
        </blockquote>
        <br />
        To find the highest prime factor of a number, we can start dividing the
        number by the smallest prime number i.e., 2, and continue looping
        through the integers while checking if each integer is a prime in order
        to divide the previous quotient by it. We keep the prime divisor at each
        iteration. The prime divisor in the last iteration gives us the highest
        prime factor of the number.
      </p>
      <div>
        <Zoom left>
          <TopBar
            language={{
              value: language,
              onChange: (e) => {
                changeDemo(problem_3a[e.target.value]);
                return changeLanguage(e.target.value);
              },
              options: Object.keys(problem_3a).map((lang) => (
                <option key={lang} value={lang}>
                  {lang}
                </option>
              )),
            }}
            toggle={{
              checked: lineNumbers,
              onChange: (e) => toggleLineNumbers(!lineNumbers),
            }}
          />
          <CopyBlock
            language={language}
            text={languageDemo}
            showLineNumbers={lineNumbers}
            theme={dracula}
            wrapLines={true}
            codeBlock
          />
        </Zoom>
      </div>
      <br />

      <div class="test-form">
        <div class="my-form">
          <h4 class="brand-title">Let's try it out</h4>
          <div class="inputs">
            <input
              type="number"
              placeholder="Enter a maximum number"
              value={maxNum}
              onChange={(e) => {
                setMaxNum(e.target.value);
                setProcess(false);
              }}
            />
            <button type="submit" onClick={shoot}>
              PROCESS
            </button>
          </div>
        </div>
      </div>

      <br />
      {process ? (
        <p>
          <Flip>
            <div class="content-card" align="center">
              <div class="card-big-shadow">
                <div
                  class="card card-just-text"
                  data-background="color"
                  data-color="blue"
                  data-radius="none"
                >
                  <div class="card-content">
                    <h4 class="description">Result</h4>
                    <h5 class="title">
                      <p>
                        The largest prime factor of the number {maxNum} is{" "}
                        <b id="value">{runProcess(maxNum)}</b>
                      </p>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Flip>
        </p>
      ) : (
        <p>
          {" "}
          <br />{" "}
        </p>
      )}
      <br />

      <p>
        There is another better way to solve this. The following method seems
        faster and it is very scalable: <br />
        <br />
        There can be at most one prime factor of a number, N that is greater
        than √N. Hence, we just need to loop through and generate prime numbers
        up to √N for the worst case. <br />
        <br />
        Starting with the first prime factor, 2 , we will reduce the original
        number by N/2 and then keep dividing N by all factors &lt; √N. <br />
        If N is not a prime number, then it will have at least 2 factors say N1
        and N2. So, in this case, N1 * N2 = N. If N1 = N2, then both are equal
        to √N. If this is not the case, then one has to be less than √N, as both
        cannot be greater than √N. <br /> <br />
        If the last quotient is greater than 1 then, the remaining number is a
        prime number and is the largest prime factor as well. <br />
        Why??? N1 &gt; √N and N2 &gt; √N implies N1 * N2 &gt; N which is not
        possible. So, if you have found all factors less than √N and divide N by
        all the factors, the remaining number is a prime number and is the
        largest prime factor. With this, you can solve this problem efficiently.
        <br /> <br />
        Below are the steps involved and the code snippets:
        <br />
        &#128073; Find square root of N and store it as endPoint <br />
        &#128073; Iterate till the value of endPoint <br />
        &#128073; In each iteration, check if i is a factor and a prime <br />
        &#128073; If no, continue loop <br />
        &#128073; If yes, reduce N with this i while you store i as the largest
        prime each time. <br />
        &#128073; When the loop completes and N &gt; 1, return this last N as
        the Largest prime factor. <br />
        &#128073; If otherwise, return the latest largest prime (i).
      </p>

      <div>
        <Zoom>
          <TopBar
            language={{
              value: language_b,
              onChange: (e) => {
                changeDemo_b(problem_3b[e.target.value]);
                return changeLanguage_b(e.target.value);
              },
              options: Object.keys(problem_3b).map((lang) => (
                <option key={lang} value={lang}>
                  {lang}
                </option>
              )),
            }}
            toggle={{
              checked: lineNumbers,
              onChange: (e) => toggleLineNumbers(!lineNumbers),
            }}
          />
          <CopyBlock
            language={language_b}
            text={languageDemo_b}
            showLineNumbers={lineNumbers}
            theme={dracula}
            wrapLines={true}
            codeBlock
          />
        </Zoom>
      </div>
      <br />
      <div class="test-form">
        <div class="my-form">
          <h4 class="brand-title">
            Let's use this method to solve the problem
          </h4>
          <div class="inputs">
            <input
              type="number"
              placeholder="Enter a maximum number"
              value={maxNumScale}
              onChange={(e) => {
                setMaxNumScale(e.target.value);
                setScaleProcess(false);
              }}
            />
            <br />
            <button type="submit" onClick={shootScale}>
              PROCESS
            </button>
          </div>
          <br />
        </div>
      </div>
      <div>
        <br />
        {scaleProcess ? (
          <p>
            <Flash>
              <div class="content-card" align="center">
                <div class="card-big-shadow">
                  <div
                    class="card card-just-text"
                    data-background="color"
                    data-color="blue"
                    data-radius="none"
                  >
                    <div class="card-content">
                      <h4 class="description">Result</h4>
                      <h5 class="title">
                        <p>
                          The largest prime factor of the number {maxNumScale}{" "}
                          is <b id="value2">{runProcessScale(maxNumScale)}</b>
                        </p>{" "}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </Flash>
          </p>
        ) : (
          <p>
            {" "}
            <br />{" "}
          </p>
        )}
      </div>
    </div>
  );
};
export default Two;
